import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api, { formatApiError } from '@/lib/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

export default function WebVersions() {
  const { siteId } = useParams();
  const [releases, setReleases] = useState([]);

  const load = () => {
    api.get(`/tenant/web/sites/${siteId}/releases`)
      .then((r) => setReleases(r.data || []))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  };
  useEffect(load, [siteId]);

  const rollback = async (id) => {
    if (!window.confirm('¿Volver a esta versión publicada?')) return;
    try {
      await api.post(`/tenant/web/sites/${siteId}/rollback/${id}`);
      toast.success('Versión restaurada');
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-4" data-testid="web-versions">
      <Link to={`/tenant/web/sites/${siteId}`} className="text-xs text-[#F72585]">← Editor</Link>
      <h1 className="text-2xl font-bold">Versiones publicadas</h1>
      <p className="text-sm text-[#64748B]">
        Cada publicación es un paquete fijo. Si algo sale mal, puedes volver a una versión anterior sin perder el borrador.
      </p>
      <ul className="space-y-2">
        {releases.map((r) => (
          <li key={r.id} className="border rounded-lg px-4 py-3 flex justify-between items-center bg-white">
            <div>
              <p className="font-medium">Versión {r.version_number}</p>
              <p className="text-xs text-[#64748B]">{r.status} · {r.published_at || r.created_at}</p>
            </div>
            <Button size="sm" variant="outline" onClick={() => rollback(r.id)}>Restaurar</Button>
          </li>
        ))}
        {!releases.length && <li className="text-sm text-[#64748B]">Aún no hay publicaciones.</li>}
      </ul>
    </div>
  );
}
